import { createFileRoute } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'
import { MyNotes } from '@/features/notes'

export const Route = createFileRoute(
  '/_authenticated/_organization/notes/'
)({
  beforeLoad: async () => requireRoles(['health_carer', 'supported_employee']),
  component: MyNotes,
})
